import { Transition } from '@headlessui/react';
import { XMarkIcon } from '@heroicons/react/20/solid';
import {
  CheckCircleIcon,
  ExclamationTriangleIcon,
  InformationCircleIcon,
} from '@heroicons/react/24/outline';
import { Fragment } from 'react';

export type SnackbarType = 'info' | 'success' | 'warn';

interface Props {
  type?: SnackbarType;
  title?: string;
  description?: string;
  show: boolean;
  afterLeave?: () => void;
  onClose: () => void;
}

export default function Snackbar({
  type,
  title,
  description,
  show,
  afterLeave,
  onClose,
}: Props) {
  return (
    <Transition
      show={show}
      as={Fragment}
      afterLeave={afterLeave}
      enter="transform ease-out duration-300 transition"
      enterFrom="translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-2"
      enterTo="translate-y-0 opacity-100 sm:translate-x-0"
      leave="transition-all ease-in duration-500"
      leaveFrom="opacity-100 max-h-[200px] "
      leaveTo="opacity-0 max-h-0"
    >
      <div className="pointer-events-auto w-full max-w-sm overflow-hidden rounded-lg bg-white shadow-lg ring-1 ring-black ring-opacity-5">
        <div className="p-4">
          <div className="flex items-start">
            <div className="flex-shrink-0">
              {type === 'info' ? (
                <InformationCircleIcon
                  className="h-6 w-6 text-gray-400"
                  aria-hidden="true"
                />
              ) : (
                <></>
              )}
              {type === 'success' ? (
                <CheckCircleIcon
                  className="h-6 w-6 text-green-400"
                  aria-hidden="true"
                />
              ) : (
                <></>
              )}
              {type === 'warn' ? (
                <ExclamationTriangleIcon
                  className="h-6 w-6 text-red-400"
                  aria-hidden="true"
                />
              ) : (
                <></>
              )}
            </div>
            <div className="ml-3 w-0 flex-1 pt-0.5">
              {title ? (
                <p className="text-sm font-medium text-gray-900">{title}</p>
              ) : (
                <></>
              )}
              {description ? (
                <p className="mt-1 text-sm text-gray-500">{description}</p>
              ) : (
                <></>
              )}
              {/* <div className="mt-3 flex space-x-7">
                <button
                  type="button"
                  className="rounded-md bg-white text-sm font-medium text-indigo-600 hover:text-indigo-500 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
                >
                  Undo
                </button>
                <button
                  type="button"
                  className="rounded-md bg-white text-sm font-medium text-gray-700 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
                >
                  Dismiss
                </button>
              </div> */}
            </div>
            <div className="ml-4 flex flex-shrink-0">
              <button
                type="button"
                className="inline-flex rounded-md bg-white text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
                onClick={() => onClose()}
              >
                <span className="sr-only">Close</span>
                <XMarkIcon className="h-5 w-5" aria-hidden="true" />
              </button>
            </div>
          </div>
        </div>
      </div>
    </Transition>
  );
}
